import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { NavigationExtras, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-assignment-resource',
  templateUrl: './assignment-resource.component.html',
  styleUrls: ['./assignment-resource.component.scss']
})
export class AssignmentResourceComponent implements OnInit {

  @Input('assignment') assignmentList: any;
  @Input('unit') singleUnit
  @Input('learner') singleLearner
  @Input('allotmentsList') allotments
  @Input('selectedElement') elementSelection
  // @Input('removedElement') elementRemoved
  @Input('allotmentRemoved') elementRemoved
  @Input('typeDisplay') selectedType
  @Input('singleQuiz') quiz
  @Input('singleJobDetails') jobDetails
  @Output() learnerAllotments: EventEmitter<any> = new EventEmitter<any>();
  @Output() elemetSelected: EventEmitter<any> = new EventEmitter<any>();
  assignments: any
  listOfAssignment: any
  learnerData
  hoverIndex
  selectedElementId: any = [];
  allotmentArray = [];
  showAllocate = false
  displayType
  selectedQuiz
  user
  jobData
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    public _userRoleService: UserRoleService
  ) {

  }
  ngOnInit() {
    this.user = JSON.parse(localStorage.userRoles);
    // console.log("what is the current user data", this.user);

  }


  ngOnChanges(changes: SimpleChanges): void {
    // console.log("changes in last page", changes);
    if (changes.jobDetails) {
      // console.log("jobDetails..........", changes.jobDetails);
      this.jobData = changes.jobDetails.currentValue;
      this.getUserRole();

    }
    if (changes.assignmentList && changes.assignmentList.currentValue) {
      this.assignments = changes.assignmentList.currentValue
      // console.log("changes in quiz", this.assignments);
    }
    if (changes.singleUnit && changes.singleUnit.currentValue) {
      this.listOfAssignment = changes.singleUnit.currentValue
      // console.log("this is in last component", this.listOfAssignment);

    }

    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
      // console.log("singleLEarner........", this.learnerData);

    }
    if (changes.allotments && changes.allotments.currentValue) {
      this.allotmentArray = changes.allotments.currentValue
    }
    if (changes.elementSelection && changes.elementSelection.currentValue) {
      this.selectedElementId = changes.elementSelection.currentValue
      // console.log("what is the selected", this.selectedElementId);

    }

    if (changes.elementRemoved && changes.elementRemoved.currentValue) {
      // console.log("this is the removed elements", changes.elementRemoved.currentValue);
      let assignments = changes.elementRemoved.currentValue
      assignments.forEach(id => {
        $("#Unassigned" + id).removeClass('selected');
        $("#Unassigned" + id).addClass('Unassigned');
      })
    }

    if (changes.selectedType && changes.selectedType.currentValue) {
      this.displayType = changes.selectedType.currentValue
    }

    if (changes.quiz && changes.quiz.currentValue) {
      this.selectedQuiz = changes.quiz.currentValue
      // console.log("selected quiz", this.selectedQuiz);

    }

  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

    return getRole

  }


  // UTILITY

  checkAssignment() {
    // console.log("what is the single item", item);
    // let index = this.listOfAssignment.filter((x) => x.assignmentId == this.assignments.assignmentId)

    if ((this.listOfAssignment.assignmentId == this.assignments.assignmentId) && this.assignments.assignmentStatus != 'Unassigned' && this.displayType == 'File') {

      return true
    } else {
      return false
    }


  }

  checkUnassign() {

    if ((this.listOfAssignment.assignmentId == this.assignments.assignmentId) && this.assignments.assignmentStatus == 'Unassigned' && this.displayType == 'File') {

      return true
    } else {
      return false
    }
  }


  checkQuiz() {
    if ((this.listOfAssignment.assignmentId == this.assignments.assignmentId) && this.displayType == 'Quiz') {
      if (this.selectedQuiz && this.selectedQuiz != undefined) {
        // console.log("%c this.selectedQuiz", "color:blue", this.selectedQuiz);

        let check = this.assignments.quiz.findIndex((x) => x._id == this.selectedQuiz._id)
        // console.log("%c check", "color:green", check)
        if (check > -1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  }


  checkUnQuiz() {
    if ((this.listOfAssignment.assignmentId != this.assignments.assignmentId)) {
      return true
    } else {
      return false
    }
  }

  checkClass() {
    if ((this.listOfAssignment.assignmentId != this.assignments.assignmentId)) {
      return 'Pending'
    }
  }


  checkStatus() {
    if ((this.listOfAssignment.assignmentId == this.assignments.assignmentId) && this.displayType == 'Quiz') {
      if (this.selectedQuiz && this.selectedQuiz != undefined) {
        // console.log("%c this.selectedQuiz", "color:blue", this.selectedQuiz);

        let check = this.assignments.quiz.findIndex((x) => x._id == this.selectedQuiz._id)
        // console.log("%c check", "color:green", check)
        if (check > -1) {
          return this.assignments.quiz[check].status
        } else {
          return 'Pending'
        }
      } else {
        return 'Pending'
      }
    } else {
      return 'Pending'
    }
  }
  quizToolTip() {
    if ((this.listOfAssignment.assignmentId == this.assignments.assignmentId) && this.displayType == 'Quiz') {
      if (this.selectedQuiz && this.selectedQuiz != undefined) {
        // console.log("%c this.selectedQuiz", "color:blue", this.selectedQuiz);

        let check = this.assignments.quiz.findIndex((x) => x._id == this.selectedQuiz._id)
        if (check > -1) {
          // console.log("%c check", "color:green", this.assignments.quiz[check])
          return this.assignments.quiz[check].status + ((this.assignments.quiz[check] && this.assignments.quiz[check].created) ? ' on ' + this.datePipe.transform(this.assignments.quiz[check].created, 'MMMM d, y') : '');
        } else {
          return 'Pending'
        }
      } else {
        return 'Pending'
      }
    } else {
      return 'Pending'
    }
  }


  async redirection() {
    console.log("this is single assignment data", this.assignments, this.user);
    if (this.assignments && this.assignments.allotmentId && this.user && !this.user.isClient) {
      console.log("hello single allotment job ===>", this.jobDetails)
      let getRole = await this.getUserRole()
      console.log("getRole getRole", getRole);
      let count = 0
      if (getRole.isAdmin) count = 0
      else if (getRole.isTrainer) count = 1
      else if (getRole.isIQA) count = 2
      else if (getRole.isLearner) count = 3
      else if (getRole.isClient) count = 4

      let param = {
        userRole: count
      }
      this.router.navigate(['/learner/allotment/' + this.assignments.allotmentId], { queryParams: param })
      // let navigationExtras: NavigationExtras = {
      //   state: {
      //     job: this.jobDetails,
      //   }
      // };
      // this.router.navigateByUrl('/learnerAllotment/' + this.assignments.allotmentId, navigationExtras)
      // this.router.navigate(['/learnerAllotment/' + this.assignments.allotmentId])
    }
  }

  unassignedClicked(assignment, learner, event) {
    console.log("what is the assignment list", event);

    this.selectedElementId.push(assignment.assignmentId + learner.learnerId)
    // console.log("***event", event.target.classList.value);
    // console.log("***assignment", assignment);
    // console.log("***learnIndex", learnIndex);
    // console.log("***Clicked", assignment.assignmentId + ',' + learn._id);
    let newData = {
      learner: learner,
      assignment: assignment,
      duedate: null
    }
    if (event.target.classList.value == 'Unassigned') {
      console.log("wchich one is call", ("#Unassigned" + assignment.assignmentId + learner.learnerId));

      $("#Unassigned" + assignment.assignmentId + learner.learnerId).removeClass('Unassigned');
      $("#Unassigned" + assignment.assignmentId + learner.learnerId).addClass('selected');
    }
    else if (event.target.classList.value == 'selected') {
      console.log("wchich one is call for second time", ("#Unassigned" + assignment.assignmentId + learner.learnerId));
      $("#Unassigned" + assignment.assignmentId + learner.learnerId).removeClass('selected');
      $("#Unassigned" + assignment.assignmentId + learner.learnerId).addClass('Unassigned');
    }

    if (this.allotmentArray) {
      let index = _.findIndex(this.allotmentArray, function (o) { return (o.learner.learnerId == newData.learner.learnerId && o.assignment.assignmentId == newData.assignment.assignmentId) })
      console.log("what is index", index);

      // if (index == -1) {
      //   this.allotmentArray.push(newData)
      // }

      if (index > -1) {
        console.log("call this first if");

        this.allotmentArray.splice(index, 1)
      }
      else {
        console.log("call this last else", newData);

        this.allotmentArray.push(newData)
      }
    } else {
      console.log("this is call for first time");

    }
    if (this.allotmentArray.length > 0) {
      // this.showAllocate = true
      this.learnerAllotments.emit(this.allotmentArray)
    } else {
      this.learnerAllotments.emit(this.allotmentArray)
    }
    // else this.showAllocate = false
    console.log("this.allotmentArray", this.allotmentArray);

    if (this.selectedElementId && this.selectedElementId.length) {
      this.elemetSelected.emit(this.selectedElementId)
    }


  }


  learnerIndex(i) {
    console.log("selcted hover index", i)
    this.hoverIndex = i;
  }



  checkArrayWithDate() {
    // let index = _.findIndex(assignmentArray, function (o) { return o.assignmentId == assignment; });
    if (this.assignments && this.assignments.allotmentId) {
      const statusAndDate = this.assignments.assignmentStatus + ' on ' + this.datePipe.transform(this.assignments.updatedAt, 'MMMM d, y');
      return statusAndDate;
    }
    //  else {
    //   // return this.isClient ? 'Unassigned' : 'Click to Allocate';
    // }

  }
}
